import React, { useState } from 'react'
import styled from 'styled-components'
import theme from '../theme.json'


export default function PrivacyPolicy({ }) {

    return (
        <Page>
            PrivacyPolicy
        </Page>

    )
}

const Page = styled.div`
    flex: 1;
    margin-top: 8vh;
    padding: 5vh 20vw 5vh 20vw;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    @media (max-width: 1100px) {
        padding: 5vh 12vw 5vh 12vw;
    }
`
